import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/sucursais';

export default {
    cadastrarSucursal(dados) {
        return http.post({
            url: baseUrl + '/inserirSucursais',
            data: dados,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.cadastrandoSucursal')
        });
    },
    listagemPaginada({ page = 0, filter = '', order = null }) {
        return http.get({
            url:
                baseUrl +
                `/listar?page=${page}&filter=${filter}&order=${order}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSucursales')
        });
    },
    listagem() {
        return http.get({
            url: baseUrl + `/listar`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSucursales')
        });
    },
    buscarSucursaisPorRevenda(idRevenda) {
        return http.get({
            url: baseUrl + `/listarSucursaisRevenda/${idRevenda}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSucursales')
        });
    },
    totalizadores(body) {
        return http.post({
            url: baseUrl + '/totalizadores/sucursalAR',
            data: body,
            lockScreen: false
        });
    },
    listagemContratos(dados, params) {
        return http.post({
            url:
                baseUrl +
                `/sucursalAR?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
            data: dados,
            lockScreen: false
        });
    },
    vizualizarContrato({ numeroContrato }) {
        return http.get({
            url: baseUrl + `/sucursalAR/visualizar/${numeroContrato}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSucursales')
        });
    },
    territoriosNaoEnviados({ contrato, pagina, tamanho }) {
        return http.get({
            url:
                baseUrl +
                `/sucursalAR/${contrato}?page=${pagina}&size=${tamanho}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },
    verificaSePodeConcluirOContrato(numeroContrato) {
        return http.get({
            url: baseUrl + '/sucursalAR/verifica-concluir-ar/' + numeroContrato,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.verificandoSeOContratoPodeSerConcluido'
            )
        });
    },
    concluirProcessamentoContrato({ contrato }) {
        return http.get({
            url: baseUrl + `/sucursalAR/concluir-processamento-ar/${contrato}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.concluindoProcessamento')
        });
    },
    buscarSaldo(idTerritorio, numeroContrato) {
        return http.get({
            url:
                baseUrl +
                `/sucursalAR/territorio/busca-saldo-ar?idTerritorio=${idTerritorio}&numeroContrato=${numeroContrato}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },
    buscarTerritoriosContrato({ contrato, pagina, tamanho }) {
        return http.get({
            url:
                baseUrl +
                `/sucursalAR/${contrato}?page=${pagina}&size=${tamanho}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },
    inserirDadosContrato(body) {
        return http.post({
            url: baseUrl + '/sucursalAR/inserir',
            data: body,
            lockScreen: true,
            lockMessage: 'Salvando dados de contrato'
        });
    },
    realizarAnaliseElegibilidade(body) {
        return http.post({
            url: baseUrl + '/sucursalAR/analisar-elegibilidade',
            data: body,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes'),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    validarRaioLocalidade(data, lockScreen = false) {
        return http.post({
            url: baseUrl + '/sucursalAR/validar-localidade',
            data: data,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    }
};
